/** The analysis page's own bands (empty van), not `loadFactorTone`'s over-capacity bands. */
export const getLoadFactorColor = (loadFactor: number) => {
  if (loadFactor >= 80) return "text-green-600"
  if (loadFactor >= 60) return "text-yellow-600"
  return "text-red-600"
}

export const getLoadFactorBgColor = (loadFactor: number) => {
  if (loadFactor >= 80) return "bg-green-100"
  if (loadFactor >= 60) return "bg-yellow-100"
  return "bg-red-100"
}
